// Main Farms.jsx (Refactored with useFarms hook)
import React from 'react';
import './farms.scss';
import SearchAndFilter from '../../../shared/SearchAndFilter';
import FarmsList from './components/FarmsList';
import useWallet from '../../../hooks/useWallet';
import useFarms from './hooks/useFarms';
import Loader from '../../../shared/Loader';
import PaginationSection from '../../../shared/PaginationSection';
import { FARMS_SORT_OPTIONS } from '../../../utils/sortConfig';

const Farms = () => {
    

    const {
        searchValue,
        sortBy,
        rootPools,
        loader,
        currentPage,
        perPage,
        totalItems,
        handleSearchChange,
        handleSortChange,
        handlePageChange,
        handlePerPageChange
    } = useFarms();

    return (
        <>
            {loader && <Loader />}
            <section className='main_Power' id='about'>
                <div className='custom-container'>
                    <div className='topp_farms'>
                        <div className='innner_topp'>
                            <h3>Discover the Top Farms</h3>
                            <SearchAndFilter
                                searchValue={searchValue}
                                onSearchChange={handleSearchChange}
                                sortBy={sortBy}
                                onSortChange={handleSortChange}
                                sortOptions={FARMS_SORT_OPTIONS}
                                searchPlaceholder='Search by name or contract...'
                            />
                        </div>

                        <FarmsList
                            farms={rootPools}
                            rootPools={rootPools}
                        />
                    </div>

                    <PaginationSection
                        currentPage={currentPage}
                        totalItems={totalItems}
                        perPage={perPage}
                        onPageChange={handlePageChange}
                        onPerPageChange={handlePerPageChange}
                    />
                </div>
            </section>
        </>
    );
};

export default Farms;